/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_AllInputs */

const en_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const zh_hans1_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const pt_br2_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas`)
};

const es_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo`)
};

const fr_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const de_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const ru_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const it_category_all = /** @type {(inputs: Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Category_AllInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_all = /** @type {((inputs?: Category_AllInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_AllInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_all(inputs)
	if (locale === "pt-BR") return pt_br2_category_all(inputs)
	if (locale === "es") return es_category_all(inputs)
	if (locale === "fr") return fr_category_all(inputs)
	if (locale === "de") return de_category_all(inputs)
	if (locale === "ru") return ru_category_all(inputs)
	if (locale === "it") return it_category_all(inputs)
	return en_category_all(inputs)
});